import { styled } from "styled-components";

const LogoImage = styled.img`
	cursor: pointer;
	display: flex;
	height: 34px;
	max-height: 100%;
	overflow: hidden;
	width: 93px;
`;

const LogoComponentWrapper = styled.div`
	display: flex;
	height: 100px;
	margin-top: 65px;
	overflow: hidden;
	width: 100px;
`;

interface ComponentProps {
	altText: string;
	imageSource: string;
	logoComponent?: React.ReactNode;
}

// This is a pretty simple component. It is the logo of the CRA organization which the user is grouped uner, and it is displayed on the left side of the nav bar.
// It offers imageSource and altText as props.
export default function NavLogo(props: ComponentProps) {
	const { altText, imageSource, logoComponent } = props;
	return (
		<>
			{logoComponent ? (
				<LogoComponentWrapper aria-label={altText} role="img">
					{logoComponent}
				</LogoComponentWrapper>
			) : (
				<LogoImage src={imageSource} alt={altText} />
			)}
		</>
	);
}
